import { useState } from "react";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import { Menu, Cpu } from "lucide-react";
import { TID } from "../../lib/testIds";

export default function AppLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen w-full bg-black text-zinc-100 md:flex">
      {/* Mobile top bar (< md) */}
      <header
        data-testid={TID.layout.mobileTopbar}
        className="md:hidden flex items-center justify-between px-4 py-3 border-b border-zinc-800 bg-zinc-950 sticky top-0 z-30"
      >
        <div className="flex items-center gap-2 min-w-0">
          <div className="h-7 w-7 rounded-md bg-white text-black grid place-items-center shrink-0">
            <Cpu className="h-3.5 w-3.5" />
          </div>
          <span className="text-sm font-semibold tracking-tight truncate">
            KRAI CONNECT
          </span>
        </div>
        <button
          data-testid={TID.layout.mobileMenuButton}
          onClick={() => setMobileOpen(true)}
          className="p-2 -mr-2 rounded-md text-zinc-300 hover:bg-zinc-900"
          aria-label="Abrir menú de navegación"
        >
          <Menu className="h-5 w-5" />
        </button>
      </header>

      <Sidebar
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <main className="flex-1 min-w-0">
        <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-6 md:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
